module.exports = __webpack_public_path__ + "img/bgcpng.e4937565.png";